import {
  Accordion,
  AccordionSummary,
  Box,
  AccordionDetails,
  Divider,
} from "@mui/material";
import React, { useMemo } from "react";
import { BiChevronDown } from "react-icons/bi";
import ItemValue from "./ItemValue";
import { RadioGroup } from "../../../../UI/RadioGroup";
import { formatCurrency } from "../../../../../utils/formatters";
import { ServiceData } from "../../../../../types/budget/service-item";
import { BudgetItemTypeEnum, Totals } from "../../../../../types/budget/budget";
import { add, format } from "date-fns";
import { resolveServiceCalcOption } from "../../../../../utils/budget-phase-calc-option";

type BudgetItemProps = {
  type: keyof typeof BudgetItemTypeEnum;
  servicesArr: any[];
  total: Totals;
  taxTotal: Totals;
  isSelected: boolean;
  selectable: boolean;
  budgetKey: keyof ServiceData;
  version: number;
  /** Status da etapa (OPEN / NEGOTIATE / APPROVED) para a NFMM da linha. */
  stageStatus?: string;
};

const BudgetItem = ({
  type,
  servicesArr,
  total,
  selectable,
  budgetKey,
  version,
  stageStatus,
}: BudgetItemProps) => {
  const servicesList = useMemo(() => {
    return servicesArr.map((el, index) => {
      const key = el._id ? `${el._id}-side-bar` : `${type}-${index}-side-bar`;
      return (
        <Box key={key}>
          <BudgetService
            serviceData={el}
            index={index}
            budgetKey={budgetKey}
            version={version}
            stageStatus={stageStatus}
          />
        </Box>
      );
    });
  }, [servicesArr, budgetKey, version, type, stageStatus]);
  return (
    <Accordion
      sx={{
        boxShadow: "none",
        my: 1,
      }}
    >
      <AccordionSummary
        expandIcon={<BiChevronDown />}
        sx={{
          display: "flex",
          alignItems: "center",
          minHeight: 40,
          maxHeight: 40,
          "&.Mui-expanded": {
            minHeight: 40,
            maxHeight: 40,
          },
        }}
      >
        <Box>
          {selectable ? (
            <RadioGroup.Item
              label={`${servicesArr.length}x ${type}`}
              value="false"
            />
          ) : (
            <> {`${servicesArr.length}x ${BudgetItemTypeEnum[type]}`}</>
          )}
        </Box>{" "}
        <Box ml={"auto"} my={"auto"}>
          {formatCurrency(total.totalInBRL)}
        </Box>
      </AccordionSummary>
      <AccordionDetails style={{ fontSize: "14px", lineHeight: "1.5" }}>
        {servicesList}

        <Divider />
        {/* <br /> */}
        {/* <ItemValue total={taxTotal.totalInBRL} savings={0} title="Taxas" /> */}
        <br />
        <ItemValue total={total.totalInBRL} savings={0} title="Total" />
      </AccordionDetails>
    </Accordion>
  );
};

type BudgetServiceProps = {
  serviceData: ServiceData;
  index: number;
  budgetKey: keyof ServiceData;
  version: number;
  stageStatus?: string;
};
function formatDate(date: string) {
  return !isNaN(new Date(date).getTime())
    ? format(add(new Date(date), { hours: 4 }), "dd/MM/yyyy")
    : "data não definida";
}
const BudgetService = ({
  serviceData,
  index,
  budgetKey,
  version,
  stageStatus,
}: BudgetServiceProps) => {
  const nfmm = resolveServiceCalcOption(serviceData, {
    version,
    status: stageStatus,
  });
  return budgetKey === "budgetValues" ? (
    <Box mb={1} px={1.5}>
      {index + 1} - {serviceData.supplierName?.slice(0, 20) || ""} <br />{" "}
      {/* {serviceData.budgetValues?.observation} */}
      <br /> {formatDate(serviceData.budgetValues.inputDate)} -{" "}
      {formatDate(serviceData.budgetValues.outDate)} (
      {serviceData.budgetValues.daily} dias) <br /> Quantidade:{" "}
      {serviceData.budgetValues.quantity} <br />
      NFMM: {nfmm} <br />
      Total: {formatCurrency(serviceData.budgetValues?.totals?.totalInBRL || 0)}
      <br />
    </Box>
  ) : budgetKey === "negotiationValue" ? (
    <Box mb={1} px={1.5}>
      {index + 1} - {serviceData.supplierName?.slice(0, 20) || ""} <br />{" "}
      {/* {serviceData.negotiationValue[version - 1]?.observation} */}
      <br /> {formatDate(
        serviceData.negotiationValue[version - 1]?.inputDate
      )}{" "}
      - {formatDate(serviceData.negotiationValue[version - 1]?.outDate)} (
      {serviceData.negotiationValue[version - 1]?.daily} dias) <br />{" "}
      Quantidade: {serviceData.negotiationValue[version - 1]?.quantity} <br />
      NFMM: {nfmm} <br />
      Total:{" "}
      {formatCurrency(
        serviceData.negotiationValue[version - 1]?.totals?.totalInBRL || 0
      )}
      <br />
    </Box>
  ) : budgetKey === "closingValues" ? (
    <Box mb={1} px={1.5}>
      {index + 1} - {serviceData.supplierName?.slice(0, 20) || ""} <br />{" "}
      {/* {serviceData.closingValues.observation} */}
      <br /> {formatDate(serviceData.closingValues.inputDate)} -{" "}
      {formatDate(serviceData.closingValues.outDate)} (
      {serviceData.closingValues.daily} dias) <br /> Quantidade:{" "}
      {serviceData.closingValues.quantity} <br />
      NFMM: {nfmm} <br />
      Total:{" "}
      {formatCurrency(serviceData.closingValues?.totals?.totalInBRL || 0)}
      <br />
    </Box>
  ) : (
    <></>
  );
};

export default BudgetItem;
